// extracted by mini-css-extract-plugin
module.exports = {"NavItems":"NavigationItems_NavItems__2Fp-X","flex":"NavigationItems_flex__1Ve_K"};